import { CircularProgress } from '@material-ui/core';

import { useStyles } from './styles';

export function LoadingOverlay(): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress size={60} color="inherit" />
    </div>
  );
}
